import Header from '../Header/Header'
import { LayoutProps } from './Layout.types'
import React from 'react'
import dynamic from 'next/dynamic'
import styles from './Layout.module.css'
import { useRouter } from 'next/router'
import { useSession } from '../../../context/Session'

// To avoid hydration errors related to the volume component making use of localStorage lets only render Player on the Client
// more info can be found here: https://nextjs.org/docs/messages/react-hydration-error
const Player = dynamic<{ interfaceText: Record<string, string> }>(
	() => import('@audio-network/player').then((mod) => mod.Player),
	{
		ssr: false, // This line ensures that the component is not rendered server side
	}
)

const Layout: React.FC<LayoutProps> = ({
	children,
	translations,
	...props
}) => {
	const { user } = useSession()
	const router = useRouter()

	const handlePlayerClick = (event: React.MouseEvent<HTMLDivElement>): void => {
		/**
		 * Logged out users should be directed to the ACQ app
		 */
		if (!user) {
			return
		}

		const target = event.target as HTMLAnchorElement
		const href = (target.tagName === 'A' ? target : target.closest('a'))?.href

		if (href) {
			event.preventDefault()
			router.push(href)
		}
	}

	return (
		<div className={styles.layout} {...props}>
			<Header />
			{children}
			{/* TODO: Player component should accept styles, onClicks etc. That will remove need for ignore rules below */}
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
			<div className={styles.player} onClick={handlePlayerClick}>
				<Player interfaceText={translations} />
			</div>
		</div>
	)
}

export default Layout
